import React, { useEffect, useState } from 'react';
import { supabase } from '../client/client';

// El aviso emergente se define en la tabla "popup": basta con marcar activo el
// registro que toque para cambiarlo, sin desplegar el sitio. Si no hay ninguno
// activo, no se muestra nada.
const Popup = ({ closePopup }) => {
  const [aviso, setAviso] = useState(null);

  useEffect(() => {
    const cargarAviso = async () => {
      const { data, error } = await supabase
        .from('popup')
        .select('id, titulo, image_url, enlace')
        .eq('activo', true)
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) {
        console.error('Error al cargar el aviso emergente:', error);
        return;
      }
      setAviso(data);
    };

    cargarAviso();
  }, []);

  // Cerrar con la tecla Escape
  useEffect(() => {
    const alPulsar = (e) => {
      if (e.key === 'Escape') closePopup();
    };
    window.addEventListener('keydown', alPulsar);
    return () => window.removeEventListener('keydown', alPulsar);
  }, [closePopup]);

  if (!aviso) return null;

  const imagen = (
    <img
      src={aviso.image_url}
      alt={aviso.titulo || 'Novedad de Cámara AQP'}
      className="image-display"
    />
  );

  return (
    <div
      className="popup-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={aviso.titulo || 'Novedad'}
      onClick={closePopup}
    >
      {/* Detiene la propagación para que pulsar sobre el contenido no cierre */}
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={closePopup} aria-label="Cerrar aviso">
          X
        </button>

        {aviso.enlace ? (
          <a href={aviso.enlace} target="_blank" rel="noopener noreferrer">
            {imagen}
          </a>
        ) : (
          imagen
        )}
      </div>
    </div>
  );
};

export default Popup;
